import { Line, mixins } from 'vue-chartjs'
const { reactiveProp } = mixins

export default {
  extends: Line,
  mixins: [reactiveProp],
  props: {
    chartData: {
      type: Object,
      default: null,

    },
    options: {
      type: Object,
      default: null,

    },
    triggerChange: true
  }, /* eslint-disable */
  watch:{
    triggerChange: function (val) {
      console.log('trig from internal')
       console.log(val)
      this.renderChart(this.chartData, this.options)
    }
  },
  mounted () {
    // this.chartData is created in the mixin.
    // If you want to pass options please create a local options object
    this.renderChart(this.chartData, this.options)
  }
}